import { untrack } from "solid-js"
import type { EntityGraphNode } from "../../core/engine/EntityGraphNode/EntityGraphNode.type"
import type { EntityThreeModel } from "./EntityThreeModel.type"

export default function createEntityThreeModel(
  node: EntityGraphNode,
  obj: EntityThreeModel['obj'] = null
): EntityThreeModel {
  return {
    h: 0,
    g: 0,
    ent: untrack(node.raw),
    node,
    obj,
  }
}